import { useContext } from "react";
import { RegistrationCtx } from "../contexts/RegistrationCtx";

function useRegistration()
{
	return useContext(RegistrationCtx);
}

export default useRegistration;
